import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Modal from "react-modal";
import { toast } from "react-toastify";
import Close from "../../assets/svgs/close.svg";
import webSocketService from "../../services/WebSocketService";
import capitalizeFirstLetter from "../../utils/capitalizeFirstLetter";
import {
  getModalCustomStyles,
  toastOptions,
} from "../../utils/constants/constants";
import Button from "../Button/Button";
import Input from "../Input/Input";
import "./ConfirmActionModal.scss";

const ConfirmActionModal = ({
  showConfirmActionModal = true,
  setShowConfirmActionModal,
  id,
  onSuccess,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);

    const result = await webSocketService.sendMessage("authorize", "c", {
      id,
      code: data?.code,
    });

    if (result === "") {
      toast.success("Authorized successfully!", toastOptions);
      await onSuccess();
      setShowConfirmActionModal(false);
    } else {
      toast.error(capitalizeFirstLetter(result), toastOptions);
    }
    setLoading(false);
  };

  return showConfirmActionModal ? (
    <Modal
      isOpen={showConfirmActionModal}
      style={getModalCustomStyles(200)}
      ariaHideApp={false}
    >
      <form className="charge-modal__wrapper" onSubmit={handleSubmit(onSubmit)}>
        <div className="charge-modal__header">
          <span className="charge-modal__header-label">
            Transaction authorization
          </span>
          <img
            className="charge-modal__close"
            src={Close}
            alt="close"
            onClick={() => setShowConfirmActionModal(false)}
          />
        </div>

        <Input
          label="Code"
          placeholder="Enter code"
          name="code"
          register={register}
          errors={errors}
          inputStyles="charge-modal__input"
          rules={{
            required: "This field is required",
          }}
        />

        <Button
          label="Confirm"
          type="submit"
          wrapperStyles="charge-modal__button"
          loading={loading}
        />
      </form>
    </Modal>
  ) : null;
};

export default ConfirmActionModal;
